import { Component, OnInit, OnDestroy } from '@angular/core';
import { RestService } from 'src/app/services/rest.service';
import { ItemInfoService } from 'src/app/services/item-info.service';
import { ItemInfo } from 'src/app/models/models';
import { Stock_Record, Store } from 'src/app/models/RestModels';
import { SubSink } from 'subsink';

interface StockRow
{
	store_id:number;
	store_name:string;
	qty:number;
}

@Component({
	selector: 'app-item-info',
	templateUrl: './item-info.component.html',
	styleUrls: ['./item-info.component.css']
})
export class ItemInfoComponent implements OnInit, OnDestroy
{
	active_section:string = 'VARIABLES';
	subs:SubSink = new SubSink();
	store_dictionary:Record<number,string> = {};

	availability_type_dic:Record<string,string> = {
		'ON_STOCK': 'En inventario',
		'BY_ORDER': 'Bajo pedido',
		'ALWAYS': 'Siempre'
	};

	applicable_tax_dic:Record<string,string> = {
		'DEFAULT': 'Predeterminado',
		'EXEMPT': 'Exento',
		'PERCENT': 'Porcentaje'
	};

	batch_option_dic:Record<string,string> = {
		'NONE': 'Sin lotes',
		'BATCH_ONLY': 'Solo lote',
		'EXPIRATION_ONLY': 'Solo vencimiento',
		'BATCH_AND_EXPIRATION': 'Lote y vencimiento'
	};

	return_action_dic:Record<string,string> = {
		'RETURN_TO_STOCK': 'Regresar a inventario',
		'ADD_TO_MERMA': 'Agregar a merma',
		'TRANSFORM_TO_PRODUCT': 'Transformar a producto'
	};

	commission_type_dic:Record<string,string> = {
		'NONE': 'Sin comisión',
		'AMOUNT': 'Monto',
		'PERCENT': 'Porcentaje',
		'RULE_PERCENT': 'Regla de porcentaje'
	};

	yes_no_dic:Record<string,string> = {
		'YES': 'Si',
		'NO': 'No'
	};

	constructor(public item_info_service:ItemInfoService, public rest:RestService)
	{
	}

	ngOnInit()
	{
		this.subs.sink = this.rest.getStores( true )
		.subscribe
		({
			next:(response)=>
			{
				response.data.forEach((store:Store)=>
				{
					if( store.id != null )
					{
						this.store_dictionary[ store.id ] = store.name || (''+store.id);
					}
				});
			},
			error:()=>
			{
			}
		});
	}

	ngOnDestroy()
	{
		this.subs.unsubscribe();
	}

	get item_info():ItemInfo | null
	{
		return this.item_info_service.item_info;
	}

	showSection(section:string)
	{
		this.active_section = section;
	}

	getStockRows():StockRow[]
	{
		let item_info = this.item_info;

		if( !item_info )
		{
			return [];
		}

		let last_by_store:Record<number,Stock_Record> = {};

		for(let record of item_info.records)
		{
			let store_id = record.store_id;

			if( record.is_current == 1 || !last_by_store[ store_id ] )
			{
				last_by_store[ store_id ] = record;
			}
		}

		let rows:StockRow[] = [];

		for(let store_id in last_by_store)
		{
			let record = last_by_store[ store_id ];
			rows.push
			({
				store_id: record.store_id,
				store_name: this.store_dictionary[ record.store_id ] || ('Sucursal '+record.store_id),
				qty: record.qty
			});
		}

		return rows;
	}

	close()
	{
		this.item_info_service.close();
	}
}
